import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

export default function AddToWatchlist({ symbol, onClose }) {
  const [watchlists, setWatchlists] = useState([]);
  const [selectedId, setSelectedId] = useState('');
  const [notes, setNotes] = useState('');
  const [status, setStatus] = useState('');

  useEffect(() => {
    api.getWatchlists().then(lists => {
      setWatchlists(lists);
      if (lists.length > 0) setSelectedId(lists[0].id);
    });
  }, []);

  const submit = async () => {
    if (!selectedId) return;
    try {
      await api.addSymbolToWatchlist(selectedId, { symbol, notes: notes || null, color_tag: 'none' });
      setStatus('success');
      setTimeout(onClose, 800);
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-title">Add {symbol} to Watchlist</div>
        {watchlists.length === 0 ? (
          <div className="muted" style={{ marginBottom: 16 }}>No watchlists yet — create one on the Watchlist page first.</div>
        ) : (
          <>
            <div className="form-group">
              <label>Watchlist</label>
              <select value={selectedId} onChange={e => setSelectedId(e.target.value)}>
                {watchlists.map(w => <option key={w.id} value={w.id}>{w.name}</option>)}
              </select>
            </div>
            <div className="form-group">
              <label>Notes (optional)</label>
              <input value={notes} onChange={e => setNotes(e.target.value)} placeholder="Why you're watching this" />
            </div>
            {status === 'success' && <div className="gain" style={{ fontSize: 13, marginBottom: 12 }}>Added successfully!</div>}
            {status === 'error' && <div className="loss" style={{ fontSize: 13, marginBottom: 12 }}>Already in this watchlist or error occurred.</div>}
          </>
        )}
        <div className="modal-actions">
          <button className="btn-ghost" onClick={onClose}>Cancel</button>
          {watchlists.length > 0 && <button className="btn" onClick={submit}>Add</button>}
        </div>
      </div>
    </div>
  );
}